import React from 'react';
import './UserBase.css';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
import Axios from 'axios';
import authClient from '../auth/Auth';
import { API } from './../constants/constants';
import { makeStyles } from '@material-ui/core/styles';

// /users

const useStyles = makeStyles(theme => ({
    button: {
        minWidth: "100px",
        marginLeft: "20px",
        marginRight: "20px"
    }
}));

export default function UserBase(props) {
    const classes = useStyles();
    const [isPLoading, setPLoading] = React.useState(false);

    /** 
    * Prepare function that retrieves number of available users and prints it in brackets of send
    * notification button of the web app
    */
    function handleAllUsers(e) {
        setPLoading(true);
        Axios.get(props.isStaging ? API.staging.allUsers : API.production.allUsers, {
            params: {},
            headers: { 'x-access-token': authClient.getIdToken() }
        })
            .then(response => {
                console.log(response);
                window.open(response.data.sheetUrl);
            })
            .catch(error => {
                // openSnack(false, printHttpError(error));
            })
            .then(() => {
                // always executed
                console.log("call finished");
                setPLoading(false);
            });
    }

    return (
        <div className="UserBase">
            <h1>User Base</h1>

            <Button className={classes.button} variant="contained" color="secondary" onClick={handleAllUsers}>
                <div>
                    Retrieve all users
                {isPLoading ? <LinearProgress /> : null}
                </div>
            </Button>
        </div>
    );
}